const copyToClipboardFallback = async (text: string) => {
    const doc = window.document;
    const isRTL = doc.documentElement.getAttribute('dir') === 'rtl';

    const input = doc.createElement('textarea');

    input.style.fontSize = '12pt';
    input.style.border = '0';
    input.style.padding = '0';
    input.style.margin = '0';
    input.style.position = 'absolute';
    input.style[isRTL ? 'right' : 'left'] = '-9999px';
    input.style.top = `${window.pageYOffset || doc.documentElement.scrollTop}px`;
    input.setAttribute('readonly', '');
    input.value = text;

    doc.body.appendChild(input);
    input.focus();
    input.select();

    const result = doc.execCommand('copy');
    doc.body.removeChild(input);

    if (!result) {
        throw new Error('Failed to copy');
    }
};

export function writeToClipboard(text: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const navigator = window.navigator;
        if (!navigator.clipboard) {
            return reject();
        }

        return navigator.clipboard.writeText(text);
    }).catch(() => {
        return copyToClipboardFallback(text);
    });
}
